<template>
  <div class="main">
    <div class="alert alert-warning mb-0">
      <p class="m-0 text-center">PREVIEW ONLY</p>
    </div>

    <div class="title-bar text-center text-sm-left">
      <h1 class="mb-2 mb-lg-0">Learning Paths</h1>
      <a
        class="btn-back text-primary"
        :href="route('admin.learning-paths.index')"
      >
        <span class="icon icon-arrow-left"></span>
        <span class="text">Back to List</span>
      </a>
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12 col-xl-6">
          <div class="learning-path-details mb-5">
            <LearningPathBanner
              :learningPath="learningPath"
              contentClass="py-3 text-center text-md-left p-md-4 p-xl-5"
              :preview="true"
            />

            <LearningPathProgressBar :learningPath="learningPath" />

            <div class="bg-white p-3 py-md-4 px-md-5">
              <div v-html="learningPath.description"></div>
              <hr class="my-4" />
              <LearningPathOverview
                :learningPath="learningPath"
                class="details-pane-table mb-5"
              />

              <LearningPathVideos
                v-if="learningPath.suggested_videos.length > 0"
                :learningPath="learningPath"
              />
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-6">
          <div class="d-none d-xl-block text-center mb-4">
            <a class="btn btn-primary" href="#">Purchase Path for Others</a>
          </div>

          <LineHeading class="mb-3">Required Courses</LineHeading>
          <LearningPathCourses :learningPath="learningPath" />

          <div
            v-if="learningPath.suggested_courses.length > 0"
            class="d-none d-lg-block mt-4"
          >
            <LineHeading class="mb-3">Other Suggested Courses</LineHeading>
            <LearningPathSuggestedCourses :learningPath="learningPath" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LearningPathBanner from "components/partials/LearningPaths/Banner";
import LearningPathProgressBar from "components/partials/LearningPaths/ProgressBar";
import LearningPathOverview from "components/partials/LearningPaths/LearningPathOverview";
import LearningPathVideos from "components/partials/LearningPaths/SuggestedVideos";
import LearningPathCourses from "components/partials/LearningPaths/RequiredCourses";
import LearningPathSuggestedCourses from "components/partials/LearningPaths/SuggestedCourses";

export default {
  components: {
    LearningPathBanner,
    LearningPathProgressBar,
    LearningPathOverview,
    LearningPathVideos,
    LearningPathCourses,
    LearningPathSuggestedCourses,
  },
  props: {
    learningPath: { type: Object, required: true },
  },
};
</script>